<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <main>
        <section class="pb-10">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <h2 class="font-semibold mt-15 text-heading-5 text-dark">
              Sekretariat
            </h2>
            <div class="border-t pt-14 border-gray-3">
              <div
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-11 gap-x-7.5"
              >
                <div class="lg:max-w-[570px] w-full">
                  <img
                    :src="`/storage/images/BGUNG.png`"
                    alt="about"
                    class="object-cover w-full h-auto"
                  />
                </div>
                <div>
                  <h5
                    class="mb-5 font-bold leading-snug tracking-wide text-heading-6 sm:text-heading-4 lg:text-heading-5 text-dark"
                  >
                    Sekretariat Dewan Pengawas Badan Layanan Umum Universitas
                    Negeri Gorontalo
                  </h5>
                  <div class="flex items-start gap-3 mt-2 mb-5">
                    <!-- Heroicons MapPin Icon (SVG) -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6 mt-1 text-primary shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 21c-4.418 0-8-5.373-8-10a8 8 0 1116 0c0 4.627-3.582 10-8 10z"
                      />
                      <circle
                        cx="12"
                        cy="11"
                        r="3"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                      />
                    </svg>
                    <p class="leading-relaxed tracking-normal">
                      Kampus I Universitas Negeri Gorontalo, Jl. Jend. Sudirman
                      No. 6, Kota Gorontalo, Provinsi Gorontalo, Indonesia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>
<script setup>
import { defineProps } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";

defineProps({
  formasi: {
    type: Object,
    required: true,
  },
});
</script>
